import _ from "lodash";
import DevicePixelRatio from "@/utils/evicePixelRatio.js";

export default {
  mounted() {
    
    if (document.body.clientWidth < 1400) {
      this.setupResizeEvent();
      // new DevicePixelRatio().init();
    }
  },
  methods: {
    setupResizeEvent() {
      const $app = this.$refs.app;
      if (!$app) return;

      const standardScale = "100%" / "100%";
      window.addEventListener(
        "load",
      () => {
          const docHeight = document.body.clientHeight;
          const docWidth = document.body.clientWidth;

          if (docWidth < 1680) {
            const currentScale = docHeight / docWidth;
            let scale = 0,
              translate = "";

            if (currentScale < standardScale) {
              scale = docHeight / 1080;
              const shouldWidth = 1920 * scale;
              const offsetWidth = docWidth - shouldWidth;
              translate =
                offsetWidth > 0 ? `translate(${offsetWidth / 2}px, 0)` : "";
            } else {
              scale = docWidth / 1920;
              const shouldHeight = 1080 * scale;
              const offsetHeight = docHeight - shouldHeight;
              // translate =
              //   offsetHeight > 0 ? `translate(0, ${offsetHeight / 2}px)` : "";
            }
            localStorage.setItem("RScale", scale);
            $app.style.cssText = `
                        transform: scale(${scale}) ${translate};
                        transform-origin: top left;
                        min-width: 1920px;
                        min-height: 1080px;
                    `;
          } else {
            $app.style.cssText = "";
            localStorage.setItem("RScale", 1);
          }
        } 
      );

      this.handleInitialResize();
    },
    handleInitialResize() {
      if (document.createEvent) {
        const event = document.createEvent("HTMLEvents");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
      } else if (document.createEventObject) {
        window.fireEvent("onresize");
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/resizemix.js